import React, { useState } from "react";
import {
  Button
} from 'reactstrap';

const DocumentPreview = (props) => {
  const file = props?.file;
  const allowedFileFormats = props?.allowedContentTypes || []

  const handleClickPreview = (e) => {
    window.open(URL.createObjectURL(file), 'blank')
  }

  const allowedFormat = () => {
    return _.includes(allowedFileFormats, file.type)
  }

  const drawButtonPreview = () => {
    if(file && allowedFormat()){
      return(
        <Button
          onClick={ (e) => handleClickPreview(e) }
          type="button"
          color="primary"
          className="btn-sm my-2"
        >
          { I18n.t(`actions.preview`)  } { I18n.t(`activerecord.models.document.one`) }
        </Button>
      )
    }
  }

  return (
    <>
      { drawButtonPreview() }
    </>
  );
};

export default DocumentPreview;
